import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./SelectUserAndWorkers.css";
import TextInput from "../UIkit/TextInput";
import SearchIcon from "@mui/icons-material/Search";
import DropdownList from "./DoropdownList";
import { toKanaString } from "../../functions/common";
import { getWorkersRecords } from "../../functions/users";
import classModule from "./SelectWorker.module.scss";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../../firebase";
import { AUTHORIZED_ORDER_USER_ROLES } from "../../functions/isAuth";
import DropdownListForOrderUser from "./DoropdownListForOrderUser";

const useStyles = makeStyles((theme) => ({
  userSearch: {
    display: "flex",
    alignItems: "center",
  },
  searchButton: {
    marginTop: "20px",
    width: "24px",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: "#757575",
  },
}));

const SelectOrderUser = (props) => {
  const classes = useStyles();
  const {
    username,
    setUsername,
    usernumber,
    setUsernumber,
    userdepnumber,
    setUserdepnumber,
    userdepname,
    setUserdepname,
    setShowSelectUser,
    email,
    setEmail,
  } = props;
  const [searchWords, setSearchWords] = useState(""); //名称
  const [userList, setUserList] = useState([]);
  const [prevUser, setPrevUser] = useState({
    userNumber: usernumber,
    userName: username,
    userDepNumber: userdepnumber,
    userDepName: userdepname,
    email: email,
  });

  //決定ボタンが押されたとき
  const handleDecideButtonClick = () => {
    setShowSelectUser(false);
  };
  //キャンセルボタンが押されたとき
  const handleCancelButtonClick = () => {
    setUsername(prevUser.userName);
    setUsernumber(prevUser.userNumber);
    setUserdepnumber(prevUser.userDepNumber);
    setUserdepname(prevUser.userDepName);
    setEmail(prevUser.email);
    setShowSelectUser(false);
  };
  useEffect(() => {
    const usersRef = collection(db, "users");
    const q = query(
      usersRef,
      where("role", "in", AUTHORIZED_ORDER_USER_ROLES)
    );
    const unsubscribe = onSnapshot(q, (snapshot) => {
      let updatedUsers = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      updatedUsers = updatedUsers.sort((a, b) => {
        return Number(a.usernumber) - Number(b.usernumber);
      });
      const updatedList = updatedUsers
        .map((user) => {
          return [
            user.usernumber,
            user.username,
            user.departmentid,
            user.departmentname,
            user.email,
          ];
        })
        .filter((user) => user[0]);
      console.log(updatedUsers);
      setUserList(updatedList);
    });

    // コンポーネントのアンマウント時にリスナーを解除
    return () => unsubscribe();
  }, []);
  return (
    <aside className={classModule.modalContainer}>
      <div className={classModule.modal}>
        <h2 className="u-text__headline u-text-center">発注担当者選択</h2>
        <DropdownListForOrderUser
          userList={userList}
          setUsername={setUsername}
          setUsernumber={setUsernumber}
          setUserdepnumber={setUserdepnumber}
          setUserdepname={setUserdepname}
          setEmail={setEmail}
        />
        <div className={classModule.buttons}>
          <button
            className={classModule.okButton}
            onClick={handleDecideButtonClick}
          >
            決定
          </button>
          <button
            className={classModule.ngButton}
            onClick={handleCancelButtonClick}
          >
            キャンセル
          </button>
        </div>
      </div>
    </aside>
  );
};

export default SelectOrderUser;
